import Icon from '@components/std-components/Icons'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles, Tooltip } from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'
import { FC } from 'react'

export interface RollupSplitActionsButtonsProps {
  isIconButton?: boolean
  iconTooltipLabel?: string
  disableButton?: boolean
  iconImageSrc?: any
  buttonLabel?: string
  handleButtonClick: any
}
const useStyles = makeStyles(theme => ({
  iconBtn: {
    padding: 0
  },
  disabledBtn: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  cursor: {
    cursor: 'pointer'
  }
}))
const RollupSplitActionsButtons: FC<RollupSplitActionsButtonsProps> = ({
  isIconButton,
  iconTooltipLabel,
  disableButton,
  iconImageSrc,
  buttonLabel,
  handleButtonClick
}) => {
  const classes = useStyles()
  return (
    <div
      className={classNames(classes.iconBtn, {
        [classes.disabledBtn]: disableButton
      })}
      onClick={() => {
        if (disableButton) {
          return
        }
        handleButtonClick()
      }}
    >
      {isIconButton ? (
        <Tooltip title={iconTooltipLabel || ''}>
          <Icon
            className={classNames({
              [classes.disabledBtn]: disableButton
            })}
            imageSrc={iconImageSrc}
          />
        </Tooltip>
      ) : (
        <CentricTypography className={classes.cursor} variant='body2Blue'>
          {buttonLabel}
        </CentricTypography>
      )}
    </div>
  )
}
export default RollupSplitActionsButtons
